import React, { Component } from "react";

export default class noSupport extends Component {
  render() {
    return (
      <div>
        <div
          style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <p style={{ alignSelf: "center" }}>
            Application doesn't support on this orientation.
          </p>
        </div>
      </div>
    );
  }
}
